import React, { useState, useEffect } from "react";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "../../../../style/buttons.scss";
import { BasketItem } from "../../../models/BasketItem";
import tryCatchRequest from "../../../api/tryCatchRequest";
import { useDispatch, useSelector } from "react-redux";
import { BsBasket3 } from "react-icons/bs";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { setAddToBasketMessage } from "../../../store/alerts/alertsActions";
import useFacility from "../../../../utils/hooks/useFacility";
import { useTranslation } from "react-i18next";
import ReactPixel from "react-facebook-pixel";
import { useNavigate } from "react-router";
import { FINALIZE_PAGE } from "../../../routes";
import { State } from "../../../store";
import { QntStateItem } from "../../../models/QntStateItem";
import EAButton from "../../shared/Buttons/EAButton";
import { gaEvent } from "../../../../utils/Analitics/ga";
import { canSendToFacebookPixel, canSendToGA } from "../../../../utils/Analitics/analiticsConfigByFacility";
import { GA_ADD_TO_CART } from "../../../../utils/Analitics/gaEventsConsts";
import { IoChevronBack } from "react-icons/io5";
import EAAlert from "../../shared/EAAlert";
import useBatchAddToBasket from "./hooks/useBatchAddToBasket";

interface IProps {
  preBasket: BasketItem[];
  clearBasket: () => void;
  ticketLimit?: number;
  qntState?: QntStateItem[];
  onBack?: () => void;
}

const PreBasketSummary: React.FC<IProps> = ({ preBasket, clearBasket, ticketLimit, qntState, onBack }: IProps) => {
  const { addToBasket } = useBatchAddToBasket();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useDesktopSize();
  const facilityIds = useFacility();
  const [alert, setAlert] = useState<string>("");
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  // Timer dla alertu - ukrywa alert po 5 sekundach
  useEffect(() => {
    if (alert && alert.length > 2 && alert !== t("dodano_bilet_do_koszyka")) {
      const timer = setTimeout(() => {
        setAlert("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [alert, t]);

  const addBasketRequest = async () => {
    const result = await addToBasket(preBasket);

    if (result.isError && result.errorTable.length > 0) {
      setAlert(result.errorTable[0]);
    } else {
      finalizeFunction();
    }

    return result;
  };

  const saveBasket = async () => {
    await tryCatchRequest(
      async () => addBasketRequest(),
      () => clearBasket(),
      dispatch,
    );

    //Metoda przejścia do koszyka po poprawnym zakupie
  };

  const finalizeFunction = () => {
    if (saleConfiguration.popupAfterAddTicket === true) {
      dispatch(setAddToBasketMessage(t("dodano_do_koszyka")));
      //  scrollToId('AddToBasketMessage')
    }

    if (saleConfiguration.popupAfterAddTicket === false) {
      setTimeout(() => {
        navigate(FINALIZE_PAGE);
      }, 300);
    }
  };

  const pixelAddBasket = () => {
    // Calculate basket total
    const basketTotal = preBasket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);

    // Google Analytics - Fix for proper GA4 ecommerce tracking
    if (canSendToGA(facilityIds)) {
      gaEvent(
        facilityIds,
        "ecommerce",
        GA_ADD_TO_CART,
        {
          event_category: "ecommerce",
          currency: "PLN",
          value: basketTotal,
          items: preBasket.map((item) => ({
            item_id: item.assortIds.replace(/^0,\+/, ""),
            item_name: item.assortName || "Produkt",
            price: item.price,
            quantity: item.qnt,
          })),
        },
        "add_to_cart",
      );
    }

    // Facebook Pixel
    if (canSendToFacebookPixel(facilityIds)) {
      const pixelValue = preBasket.length > 0 ? preBasket[0].price * preBasket[0].qnt : 0;
      ReactPixel.fbq("track", "addEventTicketToBasket", {
        value: pixelValue,
        quantity: preBasket.length > 0 ? preBasket[0].qnt : 0,
        currency: "PLN",
      });
    }
  };
  const sumBasket = () => preBasket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);

  return (
    <>
      {alert.length > 2 && alert !== t("dodano_bilet_do_koszyka") && <EAAlert type="error" message={alert} />}

      <div className="pre-basket-summary__container">
        <span className="body-text-large">
          {t("suma")}:{" "}
          <b>
            {sumBasket()} {t("zl")}
          </b>
        </span>

        <div className="pre-basket-summary__buttons">
          <EAButton
            title={isDesktop ? t("dodaj_do_koszyka") : t("dodaj")}
            endIcon={<BsBasket3 />}
            onClick={() => {
              saveBasket();
              pixelAddBasket();
            }}
            disabled={preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0) <= 0}
          />
        </div>
      </div>
      {onBack && !isDesktop && (
        <EAButton title={t("Powrót")} variant="text" startIcon={<IoChevronBack />} onClick={onBack} fullWidth />
      )}
    </>
  );
};

export default PreBasketSummary;
